import { Box, Typography } from "@mui/material";
import type { CSSProperties, Dispatch, FC, SetStateAction } from "react";
import type { Nurse } from "../../../../utils/models";
import { CommonHeader } from "../util/constants";
import { QualificationCard } from "./QualificationCard";

type Props = {
	nurse: Nurse;
	setNurseData: Dispatch<SetStateAction<Nurse>>;
	isEditable: boolean;
};
export const QualificationsAndCertifications: FC<Props> = ({ nurse, setNurseData, isEditable }) => {
	return (
		<Box
			data-testid="profile-qualifications-section"
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
			}}
		>
			<CommonHeader>{"Qualifications and Certifications" /*TODO add translations*/}</CommonHeader>
			<Box
				style={{
					marginTop: "16px",
				}}
				sx={{
					display: "flex",
					justifyContent: "space-between",
					flexWrap: "wrap",
					gap: 1,
				}}
			>
				{nurse.qualifications.map((qualification, index) => (
					<QualificationCard
						key={qualification.credential_id ?? index}
						qualification={qualification}
						onShowQualificationClicked={(q) => console.log("Show Credential clicked", q)}
						onDeleteQualificationClicked={(qualification1) => {}}
						isEditable={false}
					/>
				))}
			</Box>
		</Box>
	);
};
